import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import { ShoppingCartContextProvider } from 'src/sections/shopping_cart/ShoppingCartContext';
import ShoppingCartFilters from 'src/sections/shopping_cart/ShoppingCartFilters';
import ShoppingCartListView from 'src/sections/shopping_cart/ShoppingCartListView';
import ShoppingCartSupplierCards from 'src/sections/shopping_cart/ShoppingCartSupplierCards';
import ShoppingCartSupplierInfoSidePanelContainer from 'src/sections/shopping_cart/ShoppingCartSupplierInfoSidePanelContainer';
import 'src/style/grid/grid-override.scss';
import 'src/style/shopping-cart/ShoppingCart.scss';

const ShoppingCart = () => {
  const { t } = useTranslation();
  const { height } = useWindowSize();

  return (
    <ErrorBoundary>
      <ShoppingCartContextProvider>
        <div
          data-testid="shopping-cart-page"
          className="shopping-cart-layout min-w-0 overflow-x-hidden"
          style={{ height: `${height}px` }}
        >
          <div
            className="mb-2 min-h-0 min-w-0 max-w-full overflow-x-hidden bg-white"
            style={{ gridArea: 'navbar' }}
          >
            <div className="[&_p]:!text-[17px]">
              <Navbar title={t('Shopping Cart')} />
            </div>
            <ShoppingCartFilters />
            <ShoppingCartSupplierCards />
          </div>
          <div
            className="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden"
            style={{ gridArea: 'main' }}
          >
            <ShoppingCartListView />
          </div>
          <ShoppingCartSupplierInfoSidePanelContainer />
        </div>
      </ShoppingCartContextProvider>
    </ErrorBoundary>
  );
};

export default ShoppingCart;
